export default __webpack_public_path__ + "static/bg_about_thumbnail-fe5237d8f707fc12f113e9b5caba2ec8.jpg";